import React from "react";
import Bar from 'components/custom/Highcharts/Bar'

class LifecycleStatusBar extends React.Component {
  render() {
    const {
      report
    } = this.props

    return (
      <div>
        <Bar
          title={report.title}
          data={report.data}
          categories={report.categories}
        />
      </div>
    );
  }
}

export default LifecycleStatusBar
